import { Fragment } from 'react';

import { ServiceSisteToArRadio } from '../common/serviceSisteToArRadio';
import { InstallasjonsArRadio } from '../../../../../components/installasjonsArRadio';

export const Punktoppvarming = () => {

  return (
    <Fragment>
      <InstallasjonsArRadio
        name="varmepumpe.value.punktoppvarming"
        translationKeyPrefix="form.oppvarming.varmepumpe.installasjonsAr" />
      <ServiceSisteToArRadio name="varmepumpe.value.punktoppvarming.serviceGjennomfortSiste2Ar" />
    </Fragment>
  );
};
